import { PricingSection, PricingSectionPriceDetail } from "./PricingSection";

export default function VirtualPricing({
  title,
  description,
  additionalDescription,
  hidePriceDetailDescription,
  footer,
}) {
  return (
    <PricingSection
      title={title || "Eventive Virtual"}
      description={description}
      includedItems={[
        "Invisible forensic watermark and full multi-DRM on every screening",
        "Unlimited free trailers & pre-rolls",
        "10 feature films & 20 shorts uploaded and encoded for DRM playout on all devices",
        "Unlimited free external links for non-DRM content",
        <>Additional feature films &ndash; $25; shorts &ndash; $5</>,
        "Unlimited free livestreams",
        <>
          $0.99 per DRM unlock streaming bandwidth fee{" "}
          <i>(local currency pricing available)</i>
        </>,
        <>
          Custom domain add-on <i>(watch.yoursite.com)</i> – $500
        </>,
        <>
          Premium 1080p DRM-protected livestreams with optional live automated
          closed captioning – $10/hr
        </>,
        <>Integrated Eventive Ticketing (standard fees apply)</>,
      ]}
      additionalDescription={additionalDescription}
      priceDetail={
        <PricingSectionPriceDetail
          title="Annual activation fee"
          description={
            !hidePriceDetailDescription &&
            "Satisfaction guaranteed or we'll send you a full refund."
          }
          price="$975"
          buttonLabel="Get started"
          buttonHref="/start?goal=activate"
          secondaryButtonLabel="Request a demo"
          secondaryButtonHref="/start?goal=learn_more&message=I'd like to see a demo of Eventive Virtual."
          priceNote="USD"
          footer={footer}
        />
      }
    />
  );
}
